export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly code: string,
    message: string,
    public readonly details?: Record<string, unknown>,
    public readonly requestId?: string,
  ) {
    super(message);
    this.name = "ApiError";
  }
}

export class InvalidApiResponseError extends Error {
  constructor(public readonly endpoint: string) {
    super("The server returned an invalid response.");
    this.name = "InvalidApiResponseError";
  }
}

export const CARD_PAYMENT_READINESS_REASONS = [
  "facility_not_found",
  "stripe_connect_missing",
  "stripe_onboarding_incomplete",
  "commission_rate_missing",
  "contract_terms_not_accepted",
  "commission_rate_invalid",
  "organization_inactive",
  "payment_routing_unavailable",
] as const;

export type CardPaymentReadinessReason =
  (typeof CARD_PAYMENT_READINESS_REASONS)[number];

const CARD_PAYMENT_READINESS_REASON_SET: ReadonlySet<string> = new Set(
  CARD_PAYMENT_READINESS_REASONS,
);

export function getCardPaymentReadinessReason(
  error: ApiError,
): CardPaymentReadinessReason | null {
  const reason = error.details?.readiness_reason;
  return typeof reason === "string" &&
    CARD_PAYMENT_READINESS_REASON_SET.has(reason)
    ? (reason as CardPaymentReadinessReason)
    : null;
}

export function isApiError(error: unknown): error is ApiError {
  return error instanceof ApiError;
}
